<div class="send-links-header">
    <div class="info">
        <h2>
            Recibe tus links de pago en tu correo:
        </h2>
        <div class="disclaimer">
            <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M14.6666 9.33335H17.3333V12H14.6666V9.33335ZM14.6666 14.6667H17.3333V22.6667H14.6666V14.6667ZM16 2.66669C8.63996 2.66669 2.66663 8.64002 2.66663 16C2.66663 23.36 8.63996 29.3334 16 29.3334C23.36 29.3334 29.3333 23.36 29.3333 16C29.3333 8.64002 23.36 2.66669 16 2.66669ZM16 26.6667C10.12 26.6667 5.33329 21.88 5.33329 16C5.33329 10.12 10.12 5.33335 16 5.33335C21.88 5.33335 26.6666 10.12 26.6666 16C26.6666 21.88 21.88 26.6667 16 26.6667Z" fill="#1A4F57"/>
                </svg>
            </div>
            <p>
                Por tu seguridad, enviaremos tus links de pago y los detalles de tus causas al correo registrado en TotalAbogados. 
            </p>
        </div>
    </div>
    <div>
        <button (click)="openDialog()" >
            <div class="spinner-container">
                <mat-spinner *ngIf="isLoading" class="white-spinner"
                    [diameter]="24"
                ></mat-spinner>
            </div>
            <ng-container *ngIf="!isLoading">
                Enviar links de pago a mi correo
            </ng-container>
        </button>
    </div>
</div>
